import { Component } from 'react';
import { Field } from 'redux-form';

import { SelectField } from 'common/components/forms';
import {
  listAllCountriesOptionArray,
  countryDefinitions
} from 'common/helpers/addresses';

import CityStateFormWrapper from './CityStateFormWrapper';

class CountryCityStateFormFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCode: props.countryCode
    };
  }

  handleCountryCodeChange = (e) => {
    const { props } = this;
    const countryCode = e.target.value;
    this.setState({ countryCode });
    props.change('stateCode', null);
    props.change('city', null);
  };

  render() {
    //  we are just trying to get the city and
    // state code in the same order as they should render according to
    // the country definition document
    const { state } = this;
    let newSchema;
    let formArray = [];
    let requiredFields = [];
    const newAddressArray = [];
    if (state.countryCode) {
      newSchema = countryDefinitions[state.countryCode].schema;
      formArray = countryDefinitions[state.countryCode].formFormat;
      requiredFields = countryDefinitions[state.countryCode].requiredFormFields;
      formArray.forEach((addressLine) => {
        addressLine.forEach((element) => {
          if (element === 'stateCode' || element === 'city') {
            newAddressArray.push(element);
          }
        });
      });
    }

    return (
      <>
        <Field
          name="countryCode"
          component={SelectField}
          optionArray={listAllCountriesOptionArray(true)}
          label="Country"
          onChange={this.handleCountryCodeChange}
          required
        />
        <CityStateFormWrapper
          addressArray={newAddressArray}
          schema={newSchema}
          requiredFields={requiredFields}
        />
      </>
    );
  }
}

export default CountryCityStateFormFields;
